import dayjs from 'dayjs';

import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { ITasks } from '../type';
import { TasksRow } from './tasks-row';

interface Props {
  tableProps: TableProps;
  rows?: ITasks[];
  loading: boolean;
  totalCount?: number;
}

const TasksList = ({ tableProps, rows, loading, totalCount }: Props) => {
  const TABLE_HEAD = [
    { id: 'projectName', label: 'Project Name', align: 'center' },
    { id: 'boardName', label: 'Board Name', align: 'center' },
    { id: 'taskName', label: 'Task Name', align: 'center' },
    { id: 'assignedBy', label: 'Assigned By', align: 'center' },
    { id: 'assignee', label: 'Assignee', align: 'center' },
    { id: 'startDate/time', label: 'Start Date/Time', align: 'center' },
    { id: 'endDate/time', label: 'End Date/Time', align: 'center' },
    { id: 'completeDateTime', label: 'Complete Date/Time', align: 'center' },
    { id: 'expectedEta', label: 'Expected Time(Hour)', align: 'center' },
    { id: 'actualEta', label: 'Actual Time(Hour)', align: 'center' },
    { id: 'label', label: 'Label', align: 'center' },
    { id: 'status', label: 'Status', align: 'center', sortable: false },
  ];

  const updatedRows = rows?.map((row) => {
    return {
      ...row,
      taskName: row?.name ?? 'NA',
      description: row?.description ?? 'NA',
      assignedBy: `${row?.user?.firstName} ${row?.user?.lastName}`,
      assignedOn: row?.createdAt ? dayjs(row.createdAt).format('D MMMM YYYY') : 'NA',
      startTime: row?.startTime ? dayjs(row.startTime).format('HH:mm') : 'NA',
      dueDate: row?.dueDates?.endDate ? dayjs(row?.dueDates?.endDate).format('D MMMM YYYY') : 'N/A',
      endTime: row?.endTime ? dayjs(row.endTime).format('HH:mm') : 'NA',
      label: row?.labels?.map((label) => label.name).join(', ') || 'NA',
    };
  });

  return (
    <PaginatedTable<ITasks>
      head={TABLE_HEAD}
      tableProps={tableProps}
      totalCount={totalCount}
      data={updatedRows}
      loading={loading}
      isServerSidePaging={true}
    >
      {(row) => <TasksRow row={row} />}
    </PaginatedTable>
  );
};

export { TasksList };
